import { render, staticRenderFns } from "./Conclusao.vue?vue&type=template&id=58610ddb&"
import script from "./Conclusao.vue?vue&type=script&lang=js&"
export * from "./Conclusao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports